import React , {useEffect, useMemo, useState} from "react";
import { NavLink } from "react-router-dom";
import "./SideBar.scss";
import Logo from "../../Assets/img/logo.png";
import { PATHS } from "../../AuthService/Paths";
import { TbBooks } from "react-icons/tb";
import {
  AiOutlineCalendar,
  AiOutlineFileAdd,
  AiOutlineFileDone,
  AiOutlineMenu,
  AiOutlineMessage,
  AiOutlineSetting,
  AiOutlinePrinter,
  AiFillMoneyCollect
} from "react-icons/ai";
import { BsPersonSquare } from "react-icons/bs";
import { Trans } from "react-i18next";
import { getB2BTokens } from "../../AuthService/userData";
import { getOperationInstructionsPdfULR } from "../../Services/getOperationInstructionsPdfULR";



const navigation = [
  {
    title: "SIDE_BAR.DASHBOARD",
    to: PATHS.DASHBOARD.to,
    icon:<AiOutlineMenu/>,

    roles: PATHS.DASHBOARD.roles,
  },
  // {
  //   title: "SIDE_BAR.ACCOUNT",
  //   to: PATHS.ACCOUNT.to,
  //   icon: <BsPersonSquare />,
  //   roles: PATHS.ACCOUNT.roles,
  // },
  // {
  //   title: "SIDE_BAR.REQUESTS",
  //   to: PATHS.REQUESTS.to,
  //   icon: <AiOutlineFileDone />,
  //   roles: PATHS.REQUESTS.roles,
  // },

  // {
  //   title: "SIDE_BAR.TRANSACTIONS",
  //   to: PATHS.CASH_TRANSCATIONS.to,
  //   icon: <AiOutlineFileDone />,
  //   roles: PATHS.CASH_TRANSCATIONS.roles,
  // },
  {
    title: "SIDE_BAR.CLAIMVIEWER",
    to: PATHS.CLAIM_VIEWER.to,
    icon: <AiOutlineFileDone />,
    roles: PATHS.CLAIM_VIEWER.roles,
  },
  {
    title: "SIDE_BAR.INPATIENTVIEWER",
    to: PATHS.INPATIENT_VIEWER.to,
    icon: <AiOutlineFileDone />,
    roles: PATHS.INPATIENT_VIEWER.roles,
  },
  // {
  //   title: "SIDE_BAR.APPOINTMENTS",
  //   to: PATHS.APPOINTMENTS.to,
  //   icon: <AiOutlineCalendar />,
  //   roles: PATHS.APPOINTMENTS.roles,
  // },
  // {
  //   title: "SIDE_BAR.PATIENT_LIST",
  //   to: PATHS.PATIENT_LIST.to,
  //   icon: <AiOutlineFileAdd />,
  //   roles: PATHS.PATIENT_LIST.roles,
  // },
  //   {
  //     title: "SIDE_BAR.MESSAGES",
  //     to: PATHS.MESSAGES.to,
  //     icon: <AiOutlineMessage />,
  //     roles: PATHS.MESSAGES.roles,
  //   },
  //   {
  //     title: "SIDE_BAR.SETTINGS",
  //     to: PATHS.SETTINGS.to,
  //     icon: <AiOutlineSetting />,
  //     roles: PATHS.SETTINGS.roles,
  //   },
  {
        title: "SIDE_BAR.SETTINGS",
        to: PATHS.SETTINGS.to,
        icon: <AiOutlineSetting />,
        roles: PATHS.SETTINGS.roles,
      },
  // {
  //     title: "SIDE_BAR.PRINTCOVERLETTER",
  //     to: PATHS.PRINTCOVERLETTER.to,
  //     icon: <AiOutlinePrinter/>,
  //     permission: PATHS.PRINTCOVERLETTER.permission,
  // },
  // {
  //   title: "SIDE_BAR.FINANCIAL",
  //   to: PATHS.FINANCIAL.to,
  //   icon: <AiFillMoneyCollect/>,
  //   permission: PATHS.FINANCIAL.permission
  // },
  {
    title: "SIDE_BAR.OperationalInstructions",
    icon: <TbBooks/>,
  },

];
const SideBar = () => {
  const [operationInstructionsPdfURL,setOperationalInstructionsPdfURL]= useState()
  useEffect(()=>{
    let b2bToken = getB2BTokens()[0]
    getOperationInstructionsPdfULR(
      {
        headers: {
          payerName: b2bToken.payerName,
          authorization: `Bearer ${b2bToken.accessToken}`
        }
      }
    )
    .then(data=>setOperationalInstructionsPdfURL(data))
    .catch(error=>{
      console.log("when get Operation Instructions Pdf ULR", error);
    })
  },[])
  return (
    <>
      <div className="sidebar">
        <div className="List">
          

          <ul>
            {navigation.map((item, index) => {
              if(item.title === "SIDE_BAR.PRINTCOVERLETTER" && !getB2BTokens()[0].providerUserInfo[item.permission]) return <></>
              if(item.title === "SIDE_BAR.OperationalInstructions") return (operationInstructionsPdfURL && <a key={item.title} href={operationInstructionsPdfURL} style={{display:"flex",alignItems:"center"}} target="_blank" rel="noreferrer">
              {" "}{item.icon}
              <div style={{width:'170px'}}>
                  <Trans  i18nKey={item.title}></Trans>
                  </div>
              </a>)

              return (
                
                <NavLink key={item.title} to={item.to} style={{display:"flex",alignItems:"center"}}>
                  {" "}
                  {item.icon} 
                  <div style={{width:'170px'}}>
                  <Trans  i18nKey={item.title}></Trans>
                  </div>
                </NavLink>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideBar;
